/**
 * This class:
 * - charts time series data from a given channel
 */

import './ChannelChart.scss';
import React from 'react';
import Syncer from 'data/Syncer';
import { Chart } from 'primereact/chart';
import moment from 'moment';


const _PINK = 'rgb(255, 99, 132)';
const _GREEN = 'rgb(3, 188, 150)';


class ChannelChart extends React.Component {

  colorFn(context) {
    const index = context.dataIndex;
    const value = context.dataset.data[index];
    const t = value.t.getTime();
    const syncer = new Syncer.Factory().create();
    const synced = syncer.getSyncedTimeMillis(this.props.channel.getId()) || 0;
    return t > synced ? _PINK : _GREEN;
  }

  filterSynced(dataPoints, isSynced) {
    const syncer = new Syncer.Factory().create();
    const synced = syncer.getSyncedTimeMillis(this.props.channel.getId()) || 0;

    // TODO remove this bit. It's because we've got some times as 'Date' and some as 'moment'.
    // For now, if the dataPoint is a 'moment', it's because it's a StaticChart, so everything
    // is already synced.
    if (moment.isMoment(dataPoints[0].t)) {
      // TODO This hack puts all the data into April. Remove it.
      dataPoints.forEach(i => i.t = i.t.month(3).year(2020));
      return isSynced ? dataPoints : [];
    }

    const predicate = d => isSynced ?
      d.t.getTime() <= synced :
      d.t.getTime() >= synced;
    return dataPoints.filter(predicate);
  }

  render() {
    const channel = this.props.channel;
    const xAxisMin = this.props.xAxisMin;
    const xAxisMax = this.props.xAxisMax;
    const aspectRatio = this.props.aspectRatio || 2;
    if (!channel) {
      console.log('ChannelChart - no channel');
      return '';
    }
    const channelDataSet = channel.getData();
    let content;
    if (!channel || !channel.getData().length) {
      content = <div className='padText'>Channel loading...</div>;
    } else {
      const options = {
        title: {
          display: true,
          text: `${channel.getId()} (${channel.getUnits()})`,
        },
        animation: { duration: 0, },
        hover: { animationDuration: 0, },
        responsiveAnimationDuration: 0,
        legend: { display: false },
        scales: {
          xAxes: [{
            ticks: {
              // callback: () => '',
            },
            type: 'time',
            time: {
              min: xAxisMin,
              max: xAxisMax,
              // min: xAxisMin  - 1000 * 60 * 60 * 7,
              // max: xAxisMax  - 1000 * 60 * 60 * 7,
              // parser: t => { return t; },
            },
          }],
        },
        aspectRatio,
      };
      const data = {
        labels: ['Time'],
        datasets: [
          {
            backgroundColor: _GREEN, //this.colorFn.bind(this),
            borderColor: _GREEN,
            fill: false,
            data: this.filterSynced(channelDataSet, true),
          },
          {
            backgroundColor: _PINK,
            borderColor: _PINK,
            fill: false,
            data: this.filterSynced(channelDataSet, false),
          },
        ],
      };
      content = <Chart type='line' data={data} options={options} />;
    }
    return (
      <div className='ChannelChart'>
        <div className='content'>
          {content}
        </div>
      </div>
    );
  }
}


export default ChannelChart;

